import React from 'react'
import Tooltip from 'src/sharedComponent/tooltip'
import { Creation_Approach, Creation_Source } from 'src/constants'
import './customCellRenderer.scss'

export const customCellRenderer = (params) => {
  return (
    <Tooltip
      placement="top"
      content={params?.value ? <div className="cell_tooltip">{params?.value}</div> : 'NA'}
    >
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {params?.value || 'NA'}
      </div>
    </Tooltip>
  )
}

export const dateFormatterForPipeline = (params) => {
  if (!params.value) {
    return null
  }
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }
  const date = new Date(params?.value)
  const formattedDate = date.toLocaleString('en-US', options)

  const [weekday, monthDay, year, time] = formattedDate.split(',')
  const [month, day] = monthDay.trim().split(' ')

  return `${day} ${month.trim()} ${year.trim()}, ${time.trim()}`
}

export const shouldCostApproachCellRenderer = (params) => {
  const creationSource =
    params.data.creation_source === Creation_Source.SKU_Management
      ? Creation_Approach.top_down
      : Creation_Approach.bottom_up
  return <div className="d-flex align-items-start">{creationSource}</div>
}
